/**
 * Наступний код довідника автонумерацією (як у 1С: 9 цифр з провідними
 * нулями). Бере максимальний ЧИСЛОВИЙ код серед наявних і додає 1.
 * Нечислові коди ігноруються (щоб ручні «ADM-01» не ламали лічильник).
 */
export function nextRefCode(
  codes: (string | null | undefined)[],
  pad = 9,
): string {
  let max = 0;
  for (const c of codes) {
    if (!c) continue;
    const t = c.trim();
    if (!/^\d+$/.test(t)) continue;      // лише суто числові коди
    const n = parseInt(t, 10);
    if (n > max) max = n;
  }
  return String(max + 1).padStart(pad, '0');
}
